export default {
  searchParams: {
    name: '',
    type: 0,
    weakness: 0,
    strength: 0
  },
  pokedex: {},
  types: {},
  generationId: 1,
  generation: null
}



// WEBPACK FOOTER //
// ./src/store/state.js